import React, { useEffect, useRef } from 'react';
import c from 'classnames';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { SCREEN_TABLET } from '../../config/constants';
import './style.scss';
var TableRender = function TableRender(_ref) {
  var element = _ref.element,
    _ref$mobileCards = _ref.mobileCards,
    mobileCards = _ref$mobileCards === void 0 ? false : _ref$mobileCards,
    _ref$mobileCardsBreak = _ref.mobileCardsBreakpoint,
    mobileCardsBreakpoint = _ref$mobileCardsBreak === void 0 ? SCREEN_TABLET : _ref$mobileCardsBreak,
    _ref$transposeOnMobil = _ref.transposeOnMobile,
    transposeOnMobile = _ref$transposeOnMobil === void 0 ? false : _ref$transposeOnMobil;
  var _useWindowDimensions = useWindowDimensions(),
    width = _useWindowDimensions.width;
  var isMobile = width < mobileCardsBreakpoint;
  var tableRef = useRef(null);
  useEffect(function () {
    if (isMobile && mobileCards && tableRef.current) {
      var headerArr = [];
      tableRef.current.querySelectorAll('thead th').forEach(function (th) {
        headerArr.push(th.innerHTML);
      });
      tableRef.current.querySelectorAll('tbody tr').forEach(function (tr) {
        var count = 0;
        tr.querySelectorAll('td').forEach(function (td) {
          if (td.querySelector('p')) {
            return;
          }
          var p = document.createElement('p');
          p.classList.add('faux-th');
          p.innerText = headerArr[count];
          td.prepend(p);
          count += 1;
        });
      });
    } else {
      var _tableRef$current;
      (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.classList.add('hide-faux-th');
    }
  }, [width, isMobile, mobileCards, transposeOnMobile]);
  var displayMobileCards = isMobile && mobileCards;
  var tableClassNames = c({
    TableRender: !displayMobileCards,
    'TableRender--cards-mobile': displayMobileCards,
    'TableRender--transposedOnMobile': transposeOnMobile && !displayMobileCards
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: tableRef,
    className: tableClassNames
  }, element);
};
export default TableRender;